<template>
  <img class="default-theme" v-bind="$attrs">
  <img class="dark-theme" v-bind="darkModeAttrs">
</template>


<script>
export default {
  name: "ColorThemeImg",
  props: ['dark_theme_src'],
  inheritAttrs: false,
  computed: {
    // replaces src attribute with the dark-mode-src prop value if one exists
    darkModeAttrs() {
      const attrs = { ...this.$attrs };
      attrs.src = this.dark_theme_src ?? this.$attrs.src;
      return attrs;
    }
  },
  mounted() {
    //console.log('ColorThemeImg props', this);
  }
}
</script>


<style scoped>

/* Hide default-mode things when in dark mode */
html[data-bs-theme=dark] .default-theme {
  display: none;
}
/* Hide dark-mode things when in default mode */
html:not([data-bs-theme=dark]) .dark-theme {
  display: none;
}

</style>